// extracted by mini-css-extract-plugin
export const main = "styles-module--main--RDbwC";
export const photoCard = "styles-module--photoCard--1cOh6";
export const text = "styles-module--text--2vXDw";
export const videoSection = "styles-module--videoSection--3CDTf";
export const flip = "styles-module--flip--2aukM";